module.exports = __webpack_public_path__ + "media/chicken-road-train.222fd095.mp3";